import { AxiosError } from 'axios';
import { useSelector } from 'react-redux';
import { FormTypes } from '../models/form-models';
import { BaseAppState } from '../models/redux-state';

interface ErrorItem {
	code: string,
	message: string,
}

const getMappedApiMessage = (error: ErrorItem, messageMapping: { [key: string]: string }) => {
	if (error?.code) {
		return messageMapping[error.code] ? messageMapping[error.code] : error?.message;
	}
	return error;
};

const mapFormKey = (errorKey: string, formType: FormTypes) => {
	switch (formType) {	
		// add more form types here if any need specific mappings

		default:
			return errorKey;
	}
};

const getResponseErrors = (error: AxiosError<any>, formType?: FormTypes) => {
	try {
		const defaultErrors = error?.response?.data?.data?.errors
			|| (error?.response?.data?.data && error.response?.data?.data[0]?.errors);

		switch (formType) {
			// Add more types as needed.
			default:
				return defaultErrors;
		}
	} catch {
		return null;
	}
};

export function useApiResponseError(formType?: FormTypes) {
	const error = useSelector<BaseAppState, AxiosError[]>(state => state.apiState?.error);
	const messageMapping = {};
	const errors = {};
	if (error && error.length > 0) {
		const responseErrors = getResponseErrors(error[0], formType);
		if (responseErrors) {
			const keys = Object.keys(responseErrors);
			for (let i = 0; i < keys.length; i += 1) {
				const indexedError = responseErrors[keys[i]];
				const trimmedMappedKey = mapFormKey(keys[i].trim().toLowerCase(), formType);
				errors[trimmedMappedKey] = Array.isArray(indexedError) ? responseErrors[keys[i]].map(a => getMappedApiMessage(a, messageMapping)) : getMappedApiMessage(indexedError, messageMapping);
			}
		}
	}

	return errors;
}
